<template>
  <section class="monthly-car-renewal">
    <section class="go-back" @click="onGoBackbtn">&lt;返回</section>
    <section class="monthly-car-renewal-content">
      <el-form
        class="monthly-car-renewal-form"
        ref="rentMonthForm"
        :model="monthlyFormOrder"
        label-width="120px"
        :rules="rentMonthRules"
      >
        <el-form-item label="车牌号" prop="plateNumber">
          <el-input v-model.number="plateNumber" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="卡类型" prop="chargeRuleId" class="reset-input">
          <el-select
            :disabled="isRenewal"
            v-model="monthlyFormOrder.chargeRuleId"
            placeholder="请选择"
            @change="onChargeRuleChange"
          >
            <el-option
              v-for="item in allMonthlyChargeRuleData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡金额" prop="chargeAmount">
          <el-input
            v-model.number="monthlyFormOrder.chargeAmount"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="monthlyFormOrder.unitTypeName" prop="months">
          <el-row :gutter="20">
            <el-col :span="23">
              <el-input
                @change="onMonthChange"
                v-model.number="monthlyFormOrder.months"
              ></el-input
            ></el-col>
            <el-col :span="1">
              <div
                style="
                  height: 100%;
                  line-height: 50px;
                  color: red;
                  font-weight: bold;
                "
              >
                {{
                  monthlyFormOrder.unitType == 1
                    ? "月"
                    : monthlyFormOrder.unitType == 2
                    ? "年"
                    : ""
                }}
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="旧开始日期"
          prop="oldStartTime"
          class="reset-input"
        >
          <el-input
            v-model="monthlyFormOrder.oldStartTime"
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="旧到期日期" prop="oldEndTime" class="reset-input">
          <el-input
            v-model="monthlyFormOrder.oldEndTime"
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="开始日期" prop="startTime" class="reset-input">
          <el-date-picker
            v-model="monthlyFormOrder.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="onStartTimeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="到期日期" prop="endTime">
          <!-- <el-input
            v-model.number="monthlyFormOrder.endTime"
            
          ></el-input> -->
          <el-date-picker
            v-model="monthlyFormOrder.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="onEndTimeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="应缴金额" prop="cashAmount">
          <el-input
            v-model.number="monthlyFormOrder.cashAmount"
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="道路名称" prop="parkings" class="reset-input">
          <el-select
            multiple
            clearable
            v-model="monthlyFormOrder.parkings"
            placeholder="请选择"
          >
            <el-option
              v-for="item in parkingsDataByProperty"
              :key="item.parkingId"
              :label="item.parkingName"
              :value="item.parkingId"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <section class="buttons">
        <el-button
          :disabled="
            !(
              monthlyFormOrder.chargeRuleId &&
              monthlyFormOrder.months &&
              monthlyFormOrder.startTime
            )
          "
          class="cash-button"
          type="primary"
          @click="onCashBtn"
          >现金付款</el-button
        >
        <!-- <el-button class="qrcode-button" type="primary" @click="onQrcodeBtn"
          >扫码付款</el-button
        > -->
      </section>
    </section>
    <!--付款二维码-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        title="扫码付款"
        :visible.sync="photoDialogVisible"
        width="400px"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <div id="qrcode"></div>
        <div class="qrcode-money">应缴金额：{{ monthlyMoney }}</div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import websocket from "../../../helper/websocket";
import {
  monthlyUserAddOrEdit,
  allMonthlyChargeRule,
  getParkingsByProperty,
  lastRenewalInfo,
  monthlyRenewal,
} from "@/api/url";
// interface MonthlyOrder{
// openDate:String,
// openMonth:Number,
// openCharge:String,
// parkings:String[],

// }

import QRCode from "qrcodejs2"; // 引入qrcode

const currency = require("currency.js");
const dayjs = require("dayjs");
export default {
  name: "monthly-car-renewal",
  data() {
    return {
      isRenewal: false,
      plateNumber: "",
      recordId: "",
      parent: {},
      photoDialogVisible: false,
      allMonthlyChargeRuleData: [],
      parkingsDataByProperty: [],
      monthlyMoney: 0.0,
      monthlyFormOrder: {
        // id: "",
        // openDate: "",
        // openMonth: 0,
        // openCharge: "",
        id: "",
        chargeRuleId: "",
        chargeAmount: "",
        months: "",
        startTime: "",
        endTime: "",
        cashAmount: "",
        unitType: "1", //1:月卡，2:年卡
        unitTypeName: "月卡数",
      },
      rentMonthRules: {},
      type: "",
      // rentMonthRules: {
      //   openDate: [
      //     {
      //       required: true,
      //       trigger: ["blur", "change"],
      //       message: "请选择开通日期",
      //     },
      //   ],
      //   openMonth: [
      //     { required: true, message: "请填写开通月数", trigger: "blur" },
      //     { type: "number", message: "续费月数必须为数字值" },
      //   ],
      //   openCharge: [
      //     {
      //       required: true,
      //       message: "请选择收费规则",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      // },
    };
  },
  computed: {
    // 获取当前卡类型，年卡数，开始日期
    currentMonthlyData() {
      const { chargeRuleId, months } = this.monthlyFormOrder;
      return {
        chargeRuleId: chargeRuleId,
        months: months,
      
      };
    },
  },
  watch: {
    currentMonthlyData: {
      handler(newVal, oldVal) {
        console.log("new val=>", newVal);
        const { chargeRuleId, months } = newVal;
        const { oldStartTime, oldEndTime } = this.monthlyFormOrder;
        // if (!(chargeRuleId && months && startTime)) return;
        if (!(chargeRuleId && months)) return;
        this.monthlyFormOrder.startTime = dayjs(oldEndTime).isBefore(dayjs())//months改变后,重置续费开始时间
          ? dayjs().format("YYYY-MM-DD")
          : dayjs(oldStartTime).format("YYYY-MM-DD");
        const calculationStartTime = dayjs(oldEndTime).isBefore(dayjs())//months改变后,重置计算续费结束时间的开始时间
          ? dayjs().format("YYYY-MM-DD")
          : dayjs(oldEndTime).format("YYYY-MM-DD"); 
        this.monthlyFormOrder.endTime =
          this.monthlyFormOrder.unitType == 1
            ? dayjs(calculationStartTime)
                .add(Number(months), "month")
                // .subtract(1, "day")
                .format("YYYY-MM-DD")
            : dayjs(calculationStartTime)
                .add(Number(months), "year")
                // .subtract(1, "day")
                .format("YYYY-MM-DD");
        this.monthlyFormOrder.cashAmount = currency(
          this.monthlyFormOrder.chargeAmount
        ).multiply(currency(months)).value;
      },
      immediate: false,
      deep: true,
    },
  },

  created() {
    console.log("this.$route.query", this.$route.query);
    const monthlyInfo = JSON.parse(this.$route.query.monthlyInfo);

    this.plateNumber = monthlyInfo.plateNumber;
    this.monthlyFormOrder.id = monthlyInfo.id;
    this.type = this.$route.query.type;
    // this.recordId = this.$route.query.recordId;
    // this.road = this.$route.query.road;
  },

  mounted() {
    // const road =
    //   road && typeof JSON.parse(road) === "object" && JSON.parse(this.road);
    this.getAllMonthlyChargeRule();
    // this.reqParkingsByProperty(road?.id);
    this.initPage();
    websocket.websocketListener((msg) => {
      if (msg.type === "webPay") {
        if (msg.message === "success") {
          this.photoDialogVisible = false;
          this.$notify({
            type: "success",
            title: "续费失败",
            message: `金额：${msg.money}`,
            position: "top-right",
          });
          return;
        } else {
          this.$notify({
            type: "warning",
            title: "续费失败",
            message: "",
            position: "top-right",
          });
          return;
        }
      }
    });
  },
  methods: {
    getAllMonthlyChargeRule() {
      this.$get(allMonthlyChargeRule(), {
        // parentId: id,
      }).then((data) => {
        if (data.status != 200) return;
        this.allMonthlyChargeRuleData = data?.data ?? [];
      });
    },
    reqParkingsByProperty(id) {
      this.$get(getParkingsByProperty(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) {
          return;
        }
        this.parkingsDataByProperty = data?.data ?? {};
      });
    },
    valiForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(function (valid, noStri) {
          if (valid) {
            resolve({ status: true });
          } else {
            reject({ status: false, msg: "表单验证失败" });
          }
        });
      });
    },
    onGoBackbtn() {
      this.$router.go(-1);
    },
    async onCashBtn() {
      try {
        await this.valiForm("rentMonthForm");
        // const chargeRule = this.allMonthlyChargeRuleData.find(
        //   (rule) => rule.id === this.monthlyFormOrder.openCharge
        // );
        // const money = currency(this.monthlyFormOrder.openMonth).multiply(
        //   chargeRule.amount
        // );
        await this.$confirm(
          `现金缴费金额为${this.monthlyFormOrder.cashAmount},确认缴费请按确定。`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const { id, chargeRuleId, months, startTime, cashAmount, endTime } =
          this.monthlyFormOrder;
        const params = {
          operationType: "cash",
          id,
          chargeRuleId,
          months,
          startTime: dayjs(startTime).format("YYYY-MM-DD"),
          endTime: dayjs(endTime).format("YYYY-MM-DD"),
          cashAmount,
        };
        const monthlyData = await this.$postRequest(monthlyRenewal(), {
          ...params,
        });
        monthlyData?.status == 200
          ? (() => {
              this.$message({
                message: "缴费成功",
                type: "success",
              });
            })()
          : (() => {
              this.$message({
                message: "缴费失败",
                type: "warning",
              });
            })();
      } catch (err) {
        this.$message({
          type: "warning",
          message: err,
        });
      }
    },
    async onQrcodeBtn() {
      try {
        await this.valiForm("rentMonthForm");
        const chargeRule = this.allMonthlyChargeRuleData.find(
          (rule) => rule.id === this.monthlyFormOrder.openCharge
        );
        this.monthlyMoney = currency(this.monthlyFormOrder.openMonth).multiply(
          chargeRule.amount
        );
        const monthlyData = await this.$postRequest(monthlyUserAddOrEdit(), {
          id: this.recordId,
          months: this.monthlyFormOrder.openMonth,
          startTime: this.monthlyFormOrder.openDate,
          chargeRuleId: this.monthlyFormOrder.openCharge,
          // parkingIds: this.monthlyFormOrder.parkings,
          cashAmount: this.monthlyMoney,
          operationType: "wechat",
        });
        if (monthlyData?.status != 200) return;
        this.photoDialogVisible = true;
        this.$nextTick(() => {
          document.getElementById("qrcode").innerHTML = "";

          this.qrcode(monthlyData?.data);
        });
      } catch (err) {
        this.$message({
          type: "warning",
          message: err,
        });
      }
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        width: 360,
        height: 360,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
    },
    getLastRenewalInfo() {
      this.$get(lastRenewalInfo(), {
        plateNumber: this.plateNumber,
      }).then((data) => {
        if ((data?.data?.rentOrderInfo ?? []).length == 0) {
          this.isRenewal = false;
          //初次办卡
          this.monthlyFormOrder = {
            id: this.monthlyFormOrder.id,
            chargeRuleId: "",
            chargeAmount: "",
            months: "",
            startTime: new Date(),
            endTime: "",
            cashAmount: "",
            unitType: "1", //1:月卡，2:年卡
            unitTypeName: "月卡数",
          };
        } else {
          this.isRenewal = true;
          //续费
          const { chargeId, endTime, unitType, chargeAmount, startTime } =
            data?.data?.rentOrderInfo?.[0] ?? {};
          this.monthlyFormOrder = {
            id: this.monthlyFormOrder.id,
            chargeRuleId: chargeId,
            chargeAmount,
            months: "",
            startTime: dayjs(endTime).isBefore(dayjs())
              ? dayjs().format("YYYY-MM-DD")
              : dayjs(startTime).format("YYYY-MM-DD"),
            endTime: "",
            oldStartTime: startTime,
            oldEndTime: endTime,
            cashAmount: "",
            unitType: unitType, //1:月卡，2:年卡
            unitTypeName:
              unitType == 1 ? "月卡数" : unitType == 2 ? "年卡数" : "",
          };
        }
        console.log("last renewal info=>", data);
      });
    },
    onChargeRuleChange(value) {
      this.monthlyFormOrder.chargeAmount =
        this.allMonthlyChargeRuleData.find((rule) => rule.id === value)
          ?.amount ?? 0.0;
      this.monthlyFormOrder.unitType =
        this.allMonthlyChargeRuleData.find((rule) => rule.id === value)
          ?.unitType ?? "";
      this.monthlyFormOrder.unitTypeName =
        this.monthlyFormOrder.unitType == 1
          ? "月卡数"
          : this.monthlyFormOrder.unitType == 2
          ? "年卡数"
          : "";
    },
    onMonthChange(v) {
      console.log("v=>", v);
    },
    initPage() {
      this.type === "apply-card"
        ? (this.monthlyFormOrder = {
            id: this.monthlyFormOrder.id,
            chargeRuleId: "",
            chargeAmount: "",
            months: "",
            startTime: new Date(),
            endTime: "",
            cashAmount: "",
            unitType: "1", //1:月卡，2:年卡
            unitTypeName: "月卡数",
          })
        : this.getLastRenewalInfo();
      },
    onStartTimeChange(value){
      this.monthlyFormOrder.startTime = value;
    },
    onEndTimeChange(value){
      this.monthlyFormOrder.endTime = value;
    },
  },
};
</script>
<style scoped>
.monthly-car-renewal {
  background: white;
  width: 100%;

  padding-top: 20px;
  padding-left: 60px;

  box-sizing: border-box;
  /* display: flex;
  justify-content: center; */
}
.go-back {
  font-size: 20px;
  cursor: pointer;
}
.monthly-car-renewal-content {
  width: 100%;
  padding-right: 60px;
  box-sizing: border-box;
  height: calc(100vh - 140px);
  overflow: auto;
}
.monthly-car-renewal-form {
  width: 100%;
}
.buttons {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.cash-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
.qrcode-button {
  height: 50px;
  width: 30%;
  font-size: 20px;
  font-weight: bold;
}
</style>
<style>
.monthly-car-renewal .el-form-item {
  height: 40px;
  margin-top: 20px;
}
.monthly-car-renewal .el-col,
.monthly-car-renewal .el-row {
  height: 100%;
}
.monthly-car-renewal .el-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.monthly-car-renewal .el-form-item__content {
  height: 100%;
}
.monthly-car-renewal .el-date-editor.el-input,
.monthly-car-renewal .el-date-editor.el-input__inner {
  width: 100%;
  max-width: 100%;
  height: 100%;
}
.monthly-car-renewal .el-select {
  width: 100%;
  max-width: 100%;
}
.monthly-car-renewal .el-input__inner,
.monthly-car-renewal .el-input,
.monthly-car-renewal .el-select {
  height: 100%;
  border-radius: 6px;
}
.qrcode-money {
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}
</style>
